import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default function PageNavigation({
  prevText,
  prevLink,
  nextText,
  nextLink,
}) {
  return (
    <div className="flex justify-between mb-150 pb-10">
      {prevLink && prevText && (
        <div className="w-[270px]">
          <Link
            to={prevLink}
            className="group block border border-gray-200 rounded-lg p-4 shadow-sm hover:border-blue-500 transition-colors"
          >
            <div className="text-sm text-gray-500 mb-1 font-roboto font-weight:400">
              Previous
            </div>
            <div className="flex items-center group-hover:text-[#316BFF] transition-colors">
              <ChevronLeft className="h-5 w-5 mr-1" />
              <span
                className="font-medium font-poppins"
                style={{ fontSize: "16px", textWrap: "balance" }}
              >
                {prevText}
              </span>
            </div>
          </Link>
        </div>
      )}
      {nextLink && nextText && (
        <div className="w-[270px] ml-auto">
          <Link
            button
            to={nextLink}
            className="group flex flex-col items-end border rounded-lg p-4 shadow-sm hover:border-blue-500 transition-colors"
          >
            <div className="text-sm text-gray-500 mb-1 font-weight:400 font-roboto">
              Next
            </div>
            <div className="flex items-center  group-hover:text-[#316BFF] transition-colors">
              <span
                className="font-medium font-poppins"
                style={{ fontSize: "16px", textWrap: "balance" }}
              >
                {nextText}
              </span>
              <ChevronRight className="h-5 w-5 ml-1" />
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}
